<template>
  <div class="activity-page-list">
    <div class="filter-bar">
      <div class="input-clear-group">
        <input v-model="filters.title" placeholder="请输入标题" />
        <span v-if="filters.title" class="clear-btn" @click="filters.title = ''">×</span>
      </div>
      <div class="input-clear-group">
        <input v-model="filters.code" placeholder="请输入Code" />
        <span v-if="filters.code" class="clear-btn" @click="filters.code = ''">×</span>
      </div>
      <el-date-picker
        v-model="filters.startDate"
        type="date"
        placeholder="开始日期"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="min-width: 120px; margin-right: 8px;"
        clearable
        :editable="false"
      />
      <el-date-picker
        v-model="filters.endDate"
        type="date"
        placeholder="结束日期"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        style="min-width: 120px;"
        clearable
        :editable="false"
      />
    </div>
    <div class="action-bar">
      <button @click="fetchData">查询</button>
      <button class="add-btn" @click="addPage">新增</button>
    </div>
    <div class="list-container">
      <table>
        <thead>
          <tr>
            <th>标题</th>
            <th>Code</th>
            <th>地址</th>
            <th>创建日期</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in pageData.list" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.code }}</td>
            <td>
              <span
                class="copy-url"
                :title="getViewUrl(item.code)"
                @click="copyUrl(getViewUrl(item.code))"
              >
                {{ getViewUrl(item.code).length > 15 ? getViewUrl(item.code).slice(0, 15) + '...' : getViewUrl(item.code) }}
              </span>
            </td>
            <td>{{ formatDate(item.createTime) }}</td>
            <td>
              <button @click="previewPage(item.code)">预览</button>
              <button @click="editPage(item.id)">编辑</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!pageData.list || pageData.list.length === 0" class="empty-tip">暂无数据</div>
    </div>
    <div class="pagination-controls">
      <button :disabled="filters.pageNum === 1" @click="changePage(filters.pageNum - 1)">上一页</button>
      <span>第 {{ filters.pageNum }} 页 / 共 {{ pageData.pageNumber }} 页</span>
      <button :disabled="filters.pageNum === pageData.pageNumber" @click="changePage(filters.pageNum + 1)">下一页</button>
    </div>
  </div>
</template>

<script lang="ts">
    // 复制到剪贴板
    const copyUrl = (url: string) => {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          window.alert('地址已复制');
        });
      } else {
        // 兼容旧浏览器
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        window.alert('地址已复制');
      }
    };
    // 获取当前页面地址/view?key=code
    const getViewUrl = (code: string) => {
      return `${window.location.origin}/view?key=${code}`;
    };

import { defineComponent, reactive } from "vue";
import { ElDatePicker } from 'element-plus';
import { postData } from "@/utils/request";

interface PageItem {
  id: number;
  title: string;
  code: string;
  createTime: string;
}

export default defineComponent({
  name: "ActivityPageListComponents",
  components: { ElDatePicker },
  setup() {
    const filters = reactive({
      title: "",
      code: "",
      startDate: "",
      endDate: "",
      pageNum: 1,
      pageRow: 10,
    });

    const pageData = reactive({
      list: [] as PageItem[],
      pageNumber: 0,
      total: 0,
    });

    const fetchData = async () => {
        try {
            const response = await postData(`/kafuFour/jdUrl/page`,filters);
            Object.assign(pageData, response)
        } catch (error) {
            console.error("获取分页数据失败:", error);
        }
    };

    const changePage = (newPage: number) => {
      filters.pageNum = newPage;
      fetchData();
    };

    const previewPage = (code: string) => {
        window.open(`/view?key=${code}`, "_blank");
    };

    const editPage = (id: number) => {
      window.location.href = `/config?id=${id}`;
    };

    // 新增页面
    const addPage = () => {
      window.location.href = '/config';
    };
    // 日期格式化方法
    const formatDate = (dateStr: string) => {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      const y = d.getFullYear();
      const m = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${y}-${m}-${day}`;
    };

    fetchData();

    return {
      filters,
      pageData,
      fetchData,
      changePage,
      previewPage,
      editPage,
      formatDate,
      addPage,
      getViewUrl,
      copyUrl,
    };
  },
});
</script>

<style scoped>
.copy-url {
  cursor: pointer;
  color: #409eff;
  text-decoration: underline;
  max-width: 160px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.copy-url:hover {
  color: #f56c6c;
}
.add-btn {
  padding: 7px 22px;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
  cursor: pointer;
  margin-bottom: 8px;
  font-weight: bold;
  transition: background 0.2s;
}
.add-btn:hover {
  background: #ff7875;
}
/* 列表表格样式 */
.activity-page-list {
  max-width: 600px;
  margin: 32px auto 0 auto;
  background: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 0 0 24px 0;
}
.action-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  justify-content: flex-end;
}
.action-bar button {
  min-width: 90px;
  height: 38px;
  padding: 0 22px;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.action-bar .add-btn {
  background: #f56c6c;
}
.action-bar .add-btn:hover {
  background: #ff7875;
}
.filter-bar {
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.input-clear-group {
  position: relative;
  display: flex;
  align-items: center;
}
.input-clear-group input {
  padding: 6px 10px;
  font-size: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  min-width: 120px;
  margin-right: 0;
}
.clear-btn {
  position: absolute;
  right: 8px;
  cursor: pointer;
  color: #bbb;
  font-size: 18px;
  user-select: none;
  background: #f5f5f5;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.clear-btn:hover {
  color: #f56c6c;
}
.list-container table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}
.list-container th,
.list-container td {
  border: 1px solid #eee;
  padding: 10px 8px;
  text-align: left;
}
.list-container th {
  background: #f5f7fa;
  color: #333;
  font-weight: 500;
}
.list-container td button {
  margin-right: 8px;
  padding: 4px 12px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  background: #67c23a;
  color: #fff;
  cursor: pointer;
}
.list-container td button:last-child {
  background: #409eff;
}
.empty-tip {
  text-align: center;
  color: #bbb;
  margin-top: 40px;
  font-size: 16px;
}
.pagination-controls {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination-controls button {
  margin: 0 8px;
  padding: 6px 16px;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  cursor: pointer;
}
.pagination-controls button:disabled {
  background: #ccc;
  color: #fff;
  cursor: not-allowed;
}
</style>